module.exports = __webpack_public_path__ + "img/comingsoon.a715fce5.png";